const I18NextHttpBackend = require("i18next-http-backend");

const DOMAIN = process.env.DOMAIN || process.env.NEXT_PUBLIC_DOMAIN;

if (!DOMAIN) {
  throw new Error("Env var for DOMAIN not set");
}

const getDefaultLocaleByDomain = (domain) => {
  switch (domain) {
    case "lassie.co":
      return "sv";
    case "lassie.de":
      return "de";
    case "lassie.fr":
      return "fr";
    case "lassie.co.uk":
      return "en";
    default:
      throw new Error(
        `Cannot get sitemap locale for domain ${process.env.DOMAIN}`
      );
  }
};

const getLocalesByDomain = (domain) => {
  switch (domain) {
    case "lassie.co":
      return ["sv", "en"];
    case "lassie.de":
      return ["en", "de"];
    case "lassie.fr":
      return ["en", "fr"];
    case "lassie.co.uk":
      return ["en"];
  }
};

/** @type import("next-i18next").UserConfig */
const config = {
  i18n: {
    debug: false, // process.env.NODE_ENV === "development",
    localeDetection: false,
    defaultLocale: getDefaultLocaleByDomain(DOMAIN),
    locales: getLocalesByDomain(DOMAIN),
    backend: {
      crossDomain: true,
      request: async (options, url, payload, callback) => {
        const MAX_RETRY = 3;
        let retried = 0;
        let lastFailure;

        do {
          try {
            const ret = await fetch(url);

            if (ret.ok) {
              const data = await ret.json();
              return callback(null, {
                status: 200,
                data: JSON.stringify(data),
              });
            }

            lastFailure = new Error(`responded ${ret.status}`);
          } catch (error) {
            // `fetch` rejects on a dropped connection, a request cancelled by
            // navigating away, or a truncated body — precisely what the retry
            // is here for. Before this was caught it escaped the loop as an
            // unhandled rejection, so the one case worth retrying never was,
            // and each one reported to Sentry (47,375 events on
            // lassie-web-de alone).
            lastFailure = error;
          }

          // Wait one second
          await new Promise((resolve) => {
            setTimeout(() => {
              resolve();
            }, 1000);
          });
          retried += 1;
          console.warn(
            `translations missing on url ${url}, retrying ${retried} time`
          );
        } while (retried < MAX_RETRY);

        const failure = new Error(
          `Failed to load translations from ${url} after ${retried} retries: ${lastFailure}`
        );

        // do not allow the build if translations missing
        if (typeof window === "undefined") {
          throw failure;
        }

        // In the browser the same throw would only be an unhandled rejection
        // the visitor cannot act on. Hand it to i18next instead, which keeps
        // the page up on the translations it already holds.
        return callback(failure, null);
      },
      loadPath: (lng) => {
        const webLng = lng.includes("en") ? "en_GB" : lng;
        return `https://lassie-lokalise.s3.eu-central-1.amazonaws.com/web/locale/${webLng}.json`;
      },
    },
    react: {
      useSuspense: false,
      transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p", "li", "ol"],
    },
  },
  serializeConfig: false,
  // Every namespace here is serialized into the source of every page. The
  // mobile app's namespace ("app", 310-360 KB) was listed too, and nothing on
  // the web reads it.
  ns: ["web"],
  defaultNS: "web",
  use: [I18NextHttpBackend],
};

module.exports = config;
